import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SvgIcon, IconButton, Tooltip, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { usePopover } from "@hooks/shared/use-popover";
import { AccountPopover } from "@components/shared/elements/account-popover";
import { faCircleUser } from "@fortawesome/pro-light-svg-icons";

export const AccountButton = () => {
  const popover = usePopover();
  const location = useLocation();
  const pathname = location.pathname;
  const theme = useTheme();
  const { t } = useTranslation();

  const isActive =
    pathname === "/profile" || popover.open || pathname === "/favourites";

  return (
    <>
      <Tooltip title={t("client.profile")}>
        <IconButton
          onClick={popover.handleOpen}
          ref={popover.anchorRef}
          data-testid="account-button"
          sx={{
            backgroundColor: isActive ? alpha(theme.palette.common.white, 0.1) : "transparent",
            color: isActive ? theme.palette.primary.contrastText : theme.palette.common.white,
            fontWeight: isActive ? 700 : undefined,
          }}
        >
          <SvgIcon>
            <FontAwesomeIcon icon={faCircleUser} color="white" />
          </SvgIcon>
        </IconButton>
      </Tooltip>

      <AccountPopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
